import React, { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { studentGoals } from '../utils/mockData';
import { CheckCircleIcon, ImageIcon, FileTextIcon, UploadIcon } from 'lucide-react';
const SubmitCompletionPage: React.FC = () => {
  const {
    goalId
  } = useParams<{
    goalId: string;
  }>();
  const navigate = useNavigate();
  // Find the goal from our mock data
  const goal = studentGoals.find(g => g.id === goalId);
  const [evidence, setEvidence] = useState('');
  const [evidenceType, setEvidenceType] = useState<'text' | 'image'>('text');
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  if (!goal) {
    return <div className="max-w-3xl mx-auto text-center py-12" data-id="element-999">
        <h2 className="text-xl font-medium text-gray-800" data-id="element-1000">目标不存在</h2>
        <button onClick={() => navigate('/')} className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1001">
          返回首页
        </button>
      </div>;
  }
  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // In a real app, you would upload this file to a server
      // Here we're just creating a temporary URL
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would send the data to the server
    console.log('Submitting completion for goal:', goalId);
    console.log('Evidence:', evidenceType === 'text' ? evidence : 'Image uploaded');
    alert('完成记录提交成功！等待老师审核');
    navigate('/');
  };
  return <div className="max-w-3xl mx-auto" data-id="element-1002">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1003">提交完成记录</h1>
      <div className="bg-white rounded-lg shadow p-6 mb-6" data-id="element-1004">
        <h2 className="text-lg font-medium text-gray-800 mb-2" data-id="element-1005">目标详情</h2>
        <h3 className="font-medium text-gray-700" data-id="element-1006">{goal.title}</h3>
        <p className="text-gray-600 mt-2" data-id="element-1007">{goal.description}</p>
        <div className="mt-4 text-sm text-gray-500" data-id="element-1008">
          截止日期: {goal.deadline}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-1009">
        <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1010">提交完成证明</h2>
        <form onSubmit={handleSubmit} data-id="element-1011">
          <div className="mb-6" data-id="element-1012">
            <div className="flex space-x-4 mb-4" data-id="element-1013">
              <button type="button" onClick={() => setEvidenceType('text')} className={`flex items-center px-4 py-2 rounded-lg ${evidenceType === 'text' ? 'bg-blue-100 text-blue-700 border border-blue-300' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1014">
                <FileTextIcon size={18} className="mr-2" data-id="element-1015" />
                文字说明
              </button>
              <button type="button" onClick={() => setEvidenceType('image')} className={`flex items-center px-4 py-2 rounded-lg ${evidenceType === 'image' ? 'bg-blue-100 text-blue-700 border border-blue-300' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1016">
                <ImageIcon size={18} className="mr-2" data-id="element-1017" />
                上传图片
              </button>
            </div>
            {evidenceType === 'text' ? <textarea value={evidence} onChange={e => setEvidence(e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" rows={6} placeholder="详细描述你的完成情况..." required data-id="element-1018" /> : <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center" data-id="element-1019">
                {imagePreview ? <div data-id="element-1020">
                    <img src={imagePreview} alt="完成证明" className="max-h-64 mx-auto mb-4" data-id="element-1021" />
                    <div className="flex justify-center space-x-4" data-id="element-1022">
                      <button type="button" onClick={handleImageClick} className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-1023">
                        更换图片
                      </button>
                      <button type="button" onClick={() => setImagePreview(null)} className="text-red-600 hover:text-red-800 text-sm font-medium" data-id="element-1024">
                        移除图片
                      </button>
                    </div>
                  </div> : <div data-id="element-1025">
                    <UploadIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-1026" />
                    <p className="text-gray-600 mb-4" data-id="element-1027">
                      点击上传图片作为完成证明
                    </p>
                    <button type="button" onClick={handleImageClick} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1028">
                      选择图片
                    </button>
                  </div>}
                <input type="file" ref={fileInputRef} className="hidden" accept="image/*" onChange={handleFileChange} data-id="element-1029" />
              </div>}
          </div>
          <div className="flex justify-end" data-id="element-1030">
            <button type="button" onClick={() => navigate('/')} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors mr-4" data-id="element-1031">
              取消
            </button>
            <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center" data-id="element-1032">
              <CheckCircleIcon size={18} className="mr-2" data-id="element-1033" />
              提交完成
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default SubmitCompletionPage;